import { Component, OnInit, HostBinding, HostListener } from '@angular/core';

@Component({
  selector: 'nns-to-top',
  template: `
    <nns-icon icon="arrow-up-inv"></nns-icon>
  `,
  styles: [`
    :host {
      position:fixed;
      z-index:100;
      bottom:16px;
      right:25px;
      background: #FFFFFF;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.27);
      width:48px;
      height:48px;
      border-radius:50%;
      cursor:pointer;
      transition:all 0.3s ease-out;
      transform:translate(0,96px);
      opacity: 0;
    }

    :host.active {
      opacity:0.95;
      transform:translate(0);
    }

    nns-icon {
      display:block;
    }
  `, `
    :host-context(.nns-theme-night) {
      background:#3E4849;
      box-shadow:0 2px 4px 0 rgba(0,0,0,0.27);
    }
  `, `
    @media print {
      :host {display:none !important;}
    }
  `]
})
export class ToTopComponent implements OnInit {
  @HostBinding('class.active') isActive: boolean = false;
  scrollingContainer: Element;

  ngOnInit() {
    this.scrollingContainer = document.querySelector('nns-app');
    setTimeout(() => {
      this.isActive = true;
    }, 500);
  }

  @HostListener('click')
  scrollToTop() {
    this.scrollingContainer.scrollTo(0, 0);
  }
}
